export const FOOTER_MODULE = {
  SEARCH_ICON_SIZE: 24,

  STORE_NAMES: {
    googlePlay: 'GooglePlay',
    appStore: 'AppStore'
  },

  ACTION_TYPES: {
    storeClick: 'storeClick',
    itemClickEvent: 'itemClickEvent',
    versionClick: 'versionClick',
  },

  DYNAMIC_LINKS_DISPLAY_TYPE: {
    bettingZone: 'BETTING_ZONE',
    scores: 'SCORES'
  },

  LOGOS: {
    MAIN: {
      width: 96,
      height: 54
    },

    SOCIAL: 40,

    STORE: {
      MOBILE: {
        width: 135,
        height: 40
      },

      DESKTOP: {
        width: 179,
        height: 54
      }
    },

    LANGUAGE: {
      size: 24
    }
  },

  ANALYTICS: {
    TYPES: {
      about: 'about',
      privacy: 'privacy',
      advertise: 'advertise',
      jobs: 'jobs',
      contact: 'contact',
      terms: 'terms',
      worldCup: 'world_cup',
      publishers: 'publishers',
      deleteAccount: 'delete-account',
      betbola: 'betbola',
    },

    STORES_NAMES: {
      googlePlay: 'google-play',
      appStore: 'app-store'
    }
  },

  COPYRIGHT_TEXTS: {
    copyRight: 'Copyright ©',
    allRightReserved: '365scores.com / All rights reserved'
  },

  DYNAMIC_LINKS: {
    URL_TYPE: {
      internal: 'internal',
      external: 'external'
    }
  },

  EXTERNAL_LINKS: {
    'jobs': {
      countries: [6]
    },
    'betbola': {
      countries: [21],
    },
    'copadoMundo': {
      languages: [30, 31], //pt ,pt-br
    },
    'arab': {
    languages: [27], //ar
    },
    'rumboQatar': {
      languages: [14, 29] //es, es-mx
    },
    'publisher': {
      countries: [21],
    },
  }
}
